export enum LocalStorageVariables {
  cookiesAccepted = 'cookiesAccepted',
  signinEmail = 'signinEmail',
  hideThingtestingInfoBox = 'hideThingtestingInfoBox',
  hasSeenReviewRepliesOnboarding = 'hasSeenReviewRepliesOnboarding',
  returnToPath = 'returnToPath',
  pricingInterval = 'pricingInterval',
  hasSeenWTTOnboarding = 'hasSeenWTTOnboarding'
}
